import React, { useState, useEffect, useContext } from "react";
import UserDelegateReadOnlyRow from "./UserDelegateReadOnlyRow";
import UserDelegateTableRow from "./UserDelegateTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function UserDelegateTable({ key, setDelegate, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isDelegateLoading, setIsDelegateLoading] = useState(false);
	const [delegates, setDelegates] = useState([]);
	const [isUserDelegateLoading, setIsUserDelegateLoading] = useState(false);
	const [userDelegates, setUserDelegates] = useState([]);
	const [count, setCount] = useState(key);
	const closeText = t("page.close");
	//const today = new Date().toISOString().split("T")[0];
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	useEffect(() => {
		fetchDelegates();
		fetchUserDelegates();
	}, []);

	const handleClose = (event) => {
		setDelegate(false);
	};

	function fetchDelegates() {
		setError("");
		setIsDelegateLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: false,
				companyId: companyId,
				loginId: loginId,
			}),
		};
		try {
			FetchUtil.fetchAPI("MGetDelegates", "/Service/CompanyService/GetDelegates", requestOptions, getDelegatesSuccess, getDelegatesFail);
		} catch (error) {
			setIsDelegateLoading(false);
			throw new Error(error.message);
		}
	}

	function getDelegatesFail(redirect) {
		setIsDelegateLoading(false);
		setErrorValue([t("error.delegateNotRetrieved")]);
	}
	function getDelegatesSuccess(responseData) {
		let delegatesResponse;
		if (responseData) {
			delegatesResponse = responseData.getDelegatesResponse;
			if (delegatesResponse && delegatesResponse.errorCode === "0") {
				if (delegatesResponse.delegates) {
					setDelegates([...delegatesResponse.delegates]);
				} else {
					setDelegates([]);
					setErrorValue([t("error.delegateNotRetrieved")]);
				}
			} else if (delegatesResponse) {
				setErrorValue([t("error.error") + " " + delegatesResponse.errorMessage]);
			}
		}
		setIsDelegateLoading(false);
	}

	function fetchUserDelegates() {
		if (companyId === 0 || !loginId) {
			return;
		}
		resetCounter();
		setIsUserDelegateLoading(false);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: true,
				companyId: companyId,
				loginId: loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("MGetUserDelegates", "/Service/UserService/GetUserDelegates", requestOptions, getUserDelegatesSuccess, getUserDelegatesFail);
		} catch (error) {
			setIsUserDelegateLoading(false);
			throw new Error(error.message);
		}
	}

	function getUserDelegatesFail(redirect) {
		setIsUserDelegateLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.userDelegateNotRetrieved"));
	}

	function getUserDelegatesSuccess(responseData) {
		let userDelegatesResponse;
		setUserDelegates([]);
		if (responseData) {
			userDelegatesResponse = responseData.getUserDelegatesResponse;
			if (userDelegatesResponse && userDelegatesResponse.errorCode === "0") {
				setUserDelegates([...userDelegatesResponse.delegates]);
			} else if (userDelegatesResponse && userDelegatesResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (userDelegatesResponse) {
				setError(t("error.error") + " " + userDelegatesResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserDelegateLoading(false);
	}

	const handleDeleteClick = (event, userDelegateItem, completeCallback) => {
		event.preventDefault();
		deleteUserDelegate(userDelegateItem, completeCallback);
	};
	const deleteUserDelegate = (userDelegateItem, completeCallback) => {
		let action = 3;
		if (userDelegateItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			userDelegateKey: userDelegateItem.userDelegateKey,
			loginId: loginId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserDelegate", "/Service/UserService/DeleteUserDelegate", requestOptions, deleteUserDelegateSuccess, deleteUserDelegateFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteUserDelegateFail(redirect, completeCallback) {
		setError(t("error.userDelegateEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteUserDelegateSuccess(responseData, completeCallback) {
		let deleteUserDelegateResponse;
		if (responseData) {
			deleteUserDelegateResponse = responseData.deleteUserDelegateResponse;
			if (deleteUserDelegateResponse) {
				if (deleteUserDelegateResponse.errorCode === "0") {
					resetRowTable();
					refreshUserDelegates();
				} else {
					setError(t("error.error") + " " +
						deleteUserDelegateResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};
	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (userDelegates.length > 0) {
				userDelegates.map((userDelegateItem, index) => {
					if (userDelegateItem.companyId === setValues.delegateCompanyId && 
						userDelegateItem.delegateKey == setValues.delegateKey && 
						userDelegateItem.indirectBuyerKey == companyId) {
						setError(t("error.userDelegateDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveUserDelegate(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (completeCallback) {
			completeCallback();
		}
	};
	const saveUserDelegate = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			indirectBuyerKey: formValues.companyId,
			companyId: setValues.delegateCompanyId,
			delegateKey: setValues.delegateKey,
			level: setValues.level,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};
		try {
			FetchUtil.fetchAPI("AddUpdateUserDelegate", "/Service/UserService/AddUpdateUserDelegate", requestOptions, saveUserDelegateSuccess, saveUserDelegateFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveUserDelegateFail(redirect, completeCallback) {
		setError(t("error.userDelegateEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveUserDelegateSuccess(responseData, completeCallback) {
		let addUpdateUserDelegateResponse;
		if (responseData) {
			addUpdateUserDelegateResponse = responseData.addUpdateUserDelegateResponse;
			if (addUpdateUserDelegateResponse) {
				if (addUpdateUserDelegateResponse.errorCode === "0" || addUpdateUserDelegateResponse.errorCode === "1000") {
					resetRowTable();
					refreshUserDelegates();
				}else {
					setError(t("error.error") + " " +
						addUpdateUserDelegateResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshUserDelegates() {
		fetchUserDelegates();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isUserDelegateLoading || isDelegateLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("header.admin.delegate")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<UserDelegateTableRow
											key={count}
											delegates={delegates}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userDelegates.length % 2) > 0) ? true : false} />
									}
									{(userDelegates.length > 0) ? (
										userDelegates.map((userDelegateItem, index) => (
											<UserDelegateReadOnlyRow
												key={count}
												t={t}
												userDelegateItem={userDelegateItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												setError={setError}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<UserDelegateTableRow
											key={count}
											delegates={delegates}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userDelegates.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(userDelegates.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("header.admin.delegate")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-user-sub-close"
									id="edit-user-sub-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default UserDelegateTable;